module.exports = __webpack_public_path__ + "img/404.fb3adb08.png";